const IN_PROCESS = 'IN_PROCESS'
const FINISHED = 'FINISHED'
const CANCELED = 'CANCELED'
const FAILED = 'FAILED'
const PENDING = 'PENDING'
export type orderStates =
    | 'PENDING'
    | 'IN_PROCESS'
    | 'FINISHED'
    | 'CANCELED'
    | 'FAILED'

export const orderStatesSelect = {
    [IN_PROCESS]: {
        label: 'En Proceso',
        value: IN_PROCESS,
    },
    [PENDING]: {
        label: 'Pendiente',
        value: PENDING,
    },
    [FINISHED]: {
        label: 'Finalizado',
        value: FINISHED,
    },
    [CANCELED]: {
        label: 'Cancelado',
        value: CANCELED,
    },
    [FAILED]: {
        label: 'Fallido',
        value: FAILED,
    },
}

export const orderChangeStates = [
    orderStatesSelect[IN_PROCESS],
    orderStatesSelect[CANCELED],
    orderStatesSelect[FINISHED],
]

export const StateChutes = {
    available: 'available',
    assigned: 'assigned',
    selected: 'selected',
    not_available: 'not_available',
}

export const criteriaRules = [
    {
        title: 'Tracking',
        rules: 'Requerido | Texto | Max: 255',
    },
    {
        title: 'Regla',
        rules: 'Requerido | Texto | Max: 255',
    },
     {
        title: 'Chute',
        rules: 'Requerido | Integer | “1 - 42”',
    },
     {
        title: 'Provide Service',
        rules: 'Opcional | Texto | Max:255',
    },
]

export const preAlertRules = [
    {
        title: 'Tracking',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Provider code',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Service code',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Service code type',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Value',
        rules: 'Requerido | Decimal',
    },
    {
        title: 'Weight',
        rules: 'Requerido | Decimal',
    },
    {
        title: 'Height',
        rules: 'Opcional | Decimal',
    },
    {
        title: 'Lenght',
        rules: 'Opcional | Decimal',
    },
    {
        title: 'Zip code',
        rules: 'Opcional | Text | Máx: 255',
    },
    {
        title: 'DDP/DDU',
        rules: 'Requerido | “Y or N”',
    },
    {
        title: 'Bag',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Air waybill',
        rules: 'Requerido | Text | Máx: 255',
    },
    {
        title: 'Client code',
        rules: 'Opcional | Text | Máx: 255',
    },
    {
        title: 'Admin level 1',
        rules: 'Opcional | Text | Máx: 255',
    },
    {
        title: 'Admin level 2',
        rules: 'Opcional | Text | Máx: 255',
    },
    {
        title: 'Admin level 3',
        rules: 'Opcional | Text | Máx: 255',
    },
    {
        title: 'Hs_code',
        rules: 'Opcional | Text | Máx: 255',
    },{
        title: 'Prc',
        rules: 'Requerido | “Y or N”',
    },{
        title: 'Country',
        rules: 'Opcional | Text | Máx: 255',
    },
]
export const RolePermissions = {
    orders: {
        list: 'orders.list',
        create: 'orders.create',
        update: 'orders.update',
        delete: 'orders.delete',
        edit: 'orders.edit',
    },
    templates: {
        list: 'templates.list',
        create: 'templates.create',
        update: 'templates.update',
        delete: 'templates.delete',
        edit: 'templates.edit',
    },
    users: {
        list: 'users.list',
        create: 'users.create',
        update: 'users.update',
        delete: 'users.delete',
        edit: 'users.edit',
    },
    companies: {
        list: 'companies.list',
        create: 'companies.create',
        update: 'companies.update',
        delete: 'companies.delete',
        edit: 'companies.edit',
    },
    rules: {
        list: 'groups.list',
        create: 'groups.create',
        update: 'groups.update',
        delete: 'groups.delete',
        edit: 'groups.edit',
    },
    warehouses: {
        list: 'warehouses.list',
        create: 'warehouses.create',
        update: 'warehouses.update',
        delete: 'warehouses.delete',
        edit: 'warehouses.edit',
    },
}
